export default {
	name: 'rn-wysiwyg',
	props: {
		content: {
			type: String,
			default: '',
		},
	},
};
